import { traverseStoryboardExpressions } from "./expressions/index.js";
import { traverseStoryboardFunctions } from "./functions/index.js";
const PERMISSIONS = "PERMISSIONS";
const check = "check";
export function scanPermissionActionsInStoryboard(storyboard) {
  var _storyboard$meta;
  const collection = new Set();
  const beforeVisitPermissions = beforeVisitPermissionsFactory(collection);
  const {
    customTemplates,
    functions
  } = (_storyboard$meta = storyboard.meta) !== null && _storyboard$meta !== void 0 ? _storyboard$meta : {};
  traverseStoryboardExpressions([storyboard.routes, customTemplates], beforeVisitPermissions, PERMISSIONS);
  traverseStoryboardFunctions(functions, beforeVisitPermissions, {
    matchSource(source) {
      return source.includes(PERMISSIONS);
    }
  });
  return Array.from(collection);
}
export function scanPermissionActionsInAny(data) {
  const collection = new Set();
  traverseStoryboardExpressions(data, beforeVisitPermissionsFactory(collection), PERMISSIONS);
  return Array.from(collection);
}
function beforeVisitPermissionsFactory(collection) {
  return function beforeVisitPermissions(node, parent) {
    if (node.name === PERMISSIONS) {
      const memberParent = parent[parent.length - 1];
      const callParent = parent[parent.length - 2];
      if ((callParent === null || callParent === void 0 ? void 0 : callParent.node.type) === "CallExpression" && (callParent === null || callParent === void 0 ? void 0 : callParent.key) === "callee" && (memberParent === null || memberParent === void 0 ? void 0 : memberParent.node.type) === "MemberExpression" && memberParent.key === "object" && (memberParent.node.computed ? memberParent.node.property.type === "Literal" && memberParent.node.property.value === check : memberParent.node.property.type === "Identifier" && memberParent.node.property.name === check)) {
        for (const arg of callParent.node.arguments) {
          if (arg.type === "Literal" && typeof arg.value === "string") {
            collection.add(arg.value);
          }
        }
      }
    }
  };
}
//# sourceMappingURL=permissions.js.map